import { render, staticRenderFns } from "./ZoomedMediumPc.vue?vue&type=template&id=b8f490b6&scoped=true"
import script from "./ZoomedMediumPc.vue?vue&type=script&lang=js"
export * from "./ZoomedMediumPc.vue?vue&type=script&lang=js"
import style0 from "./ZoomedMediumPc.vue?vue&type=style&index=0&id=b8f490b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f490b6",
  null
  
)

export default component.exports